/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import './bootstrap.min.css';
import "./layout.css"

import Navbar from "./Globals/Navbar" /*Introducing Navbar within the Layout section so that it is always included in our pages */
import Footer from "./Globals/Footer"
const Layout = ({ children }) => (
  <>
  <Navbar />
    {children}
  <Footer />
  </>
);


Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
